export const DOCUMENTTYPE_CREATE_RESET = 'DOCUMENTTYPE_CREATE_RESET'
export const DOCUMENTTYPE_CREATE_SET_CREATED = 'DOCUMENTTYPE_CREATE_SET_CREATED'
export const DOCUMENTTYPE_CREATE_SET_ERROR = 'DOCUMENTTYPE_CREATE_SET_ERROR'
export const DOCUMENTTYPE_CREATE_SET_VIOLATIONS = 'DOCUMENTTYPE_CREATE_SET_VIOLATIONS'
export const DOCUMENTTYPE_CREATE_TOGGLE_LOADING = 'DOCUMENTTYPE_CREATE_TOGGLE_LOADING'
